import gsap from 'gsap';
import React, { useEffect, useRef } from 'react';

const DotNavigation = ({ sections, currentSection, onSectionChange }) => {
  const dotsRef = useRef([]);

  useEffect(() => {
    // Animate dots in sequence
    gsap.fromTo(dotsRef.current,
      { 
        opacity: 0,
        scale: 0,
        y: -20
      },
      {
        opacity: 1,
        scale: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.1,
        ease: "back.out(1.7)"
      }
    );
  }, []);

  // Animate selected dot
  useEffect(() => {
    dotsRef.current.forEach((dot, index) => {
      const isSelected = currentSection === index + 1;
      gsap.to(dot.querySelector('.inner-dot'), {
        scale: isSelected ? 1.2 : 1,
        duration: 0.3,
        ease: "power2.out"
      });
    });
  }, [currentSection]);

  return (
    <div style={{
      position: 'fixed',
      right: '2rem',
      top: '50%',
      transform: 'translateY(-50%)',
      display: 'flex',
      flexDirection: 'column',
      gap: '2rem',
      zIndex: 1000
    }}>
      {sections.slice(1).map((section, index) => {
        const actualIndex = index + 1;
        const isSelected = currentSection === actualIndex;
        
        return (
          <div
            key={section.name}
            ref={el => dotsRef.current[index] = el}
            style={{
              position: 'relative',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem'
            }}
            onClick={() => onSectionChange(actualIndex)}
          >
            {/* Hover Label */}
            <div style={{
              position: 'absolute',
              right: '2.5rem',
              background: 'rgba(255, 255, 255, 0.9)',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              color: '#000',
              fontSize: '0.875rem',
              whiteSpace: 'nowrap',
              opacity: 0,
              transform: 'translateX(-1rem)',
              transition: 'all 0.3s ease',
              pointerEvents: 'none'
            }}>
              {section.name === "DEFAULT" ? "HOME" : section.name}
            </div>
            
            {/* Navigation Dot Container */}
            <div style={{
              position: 'relative',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {/* Outer Stroke */}
              <div style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                border: isSelected ? '2px solid rgba(255, 255, 255, 0.8)' : 'none',
                transition: 'all 0.3s ease'
              }} />
              
              {/* Inner Dot */}
              <div 
                className="inner-dot"
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: isSelected ? '#fff' : 'rgba(255, 255, 255, 0.3)',
                  transition: 'all 0.3s ease'
                }} 
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DotNavigation; 